export const FORCED_COLORS_FOR_STRING = {
  'Any label' : [0, 0, 0],
  'Any Label' : [0, 0, 0],
  'All Labels': [0, 0, 0],
  'All labels': [0, 0, 0],
};
